module.exports = __webpack_public_path__ + "img/applepay_logo-min.7ca1038c.png";